export default {
    baseURL: 'https://api.longyuteam.com',
    // baseURL: 'https://api.moyuteams.com/',
    // baseURL: 'https://moyuteams.com/',
}